import React from 'react';

import { Menu } from '~/components';

import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
} from 'react-router-dom';

import { Session } from '~/components';

import { useAuth } from '~/hooks/authentication';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (!user || !user.token) {
          return (
            <>
              <Session />
            </>
          );
        }

        return (
          <>
            <Menu />
            {/* @ts-ignore */}
            <>{<Component />}</>
          </>
        );
      }}
    />
  );
};

export default Route;
